// extracted by mini-css-extract-plugin
export default {"banner":"oCp0D","inversed":"BHb4u","imageContainer":"tXAG_","container":"XBk2j","title":"pqH7F","subtitle":"KRYXT","condition":"cBi8s","image":"sE891"};